import { render, staticRenderFns } from "./PersonalPendingVouchers.vue?vue&type=template&id=d054a418&scoped=true"
import script from "./PersonalPendingVouchers.vue?vue&type=script&lang=js"
export * from "./PersonalPendingVouchers.vue?vue&type=script&lang=js"
import style0 from "./PersonalPendingVouchers.vue?vue&type=style&index=0&id=d054a418&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d054a418",
  null
  
)

export default component.exports